
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import ModalMixin from "./mixin";
import BarcodeOrderInventoryLinking from "@/components/barcodeSystem/barcodeOrder/BarcodeOrderInventoryLinking.vue";
import { LinkInventoryRequest } from "@/models/api/barcodeSystem/barcodeOrders/linkInventory";
import notifications from "@/lib/notifications";
import LinkInventoryItemFilters from "@/components/barcodeSystem/inventory/LinkInventoryItemFilters.vue";
import LinkInventoryItemTable from "@/components/barcodeSystem/inventory/LinkInventoryItemTable.vue";
import { defaultLinkItemFilters } from "@/store/modules/barcodeSystem/inventory/helpers";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);
const inventoryModuleState = getModule(InventoryModule);

@Component({
  name: modals.linkInventoryToOrderModal,
  components: {
    BarcodeOrderInventoryLinking,
    LinkInventoryItemFilters,
    LinkInventoryItemTable
  }
})
export default class LinkInventoryToOrderModal extends ModalMixin {
  loadingComplete: boolean = false;
  showInventoryItemFieldFilter: boolean = false;
  request: LinkInventoryRequest = null;
  showAddInventoryItemModal: boolean = false;
  isSaving: boolean = false;
  LINK_INVENTORY_ITEM_MENU_ITEM: any = [
    { title: "Add Item", type: "addItem" },
    { title: "Add Model", type: "addModel", maxSelection:1}
  ];

  async load() {
    this.loadingComplete = false;
    this.show();
    inventoryModuleState.resetLinkItemList();
    try {
      this.request = await barcodeOrderModuleState.previewLinkInventory(this.selectedItem.id); 
      let filter = defaultLinkItemFilters();
      filter.companyIds = [this.request.companyId ? this.request.companyId : -1];
      filter.facilityCodes = [ this.request.facilityCode ? this.request.facilityCode : ""];
      this.setLinkItemFilters();
    } catch (ex) {
      notifications.error("Failed to load inventory linking data", "Failed to load inventory linking data.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  setLinkItemFilters(){
    let filter = defaultLinkItemFilters();
    if(this.request)
    {
      filter.companyIds = [this.request.companyId ? this.request.companyId : -1];
      filter.facilityCodes = [ this.request.facilityCode ? this.request.facilityCode : ""];
    }
    inventoryModuleState.setLinkItemFilters(filter);
  }

  async reloadRequest(){
    if(this.request)
    {
      this.loadingComplete = false;
      try
      {
        this.request = await barcodeOrderModuleState.previewLinkInventory(this.request.id);
      } catch (ex) {
        notifications.error("Failed to reload inventory linking data", "Failed to reload inventory linking data.", ex);
      }
      this.loadingComplete = true;
    }
  }

  async save() {
    if(this.request)
    {
      this.isSaving = true; try
      {
        await barcodeOrderModuleState.linkInventory(this.request);
        notifications.success("Saved Successful", "Saved Linked Inventory.");
        this.reloadRequest();
      } catch (ex) {
        notifications.error("Failed to save", "Failed to save linked inventory.", ex);
      }
      this.isSaving = false;
    }
  }

  addInventory() {
    this.showAddInventoryItemModal = true;
  }

  closeModals() {
    this.showAddInventoryItemModal = false;
  }

  reset() {
    this.request = null;
    this.closeModals();
  }


  get itemFields() {
    return inventoryModuleState.itemFields;
  }

  async created() {
    /*await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getInventorySummary({
      pageNumber: 1,
      pageSize: inventoryModuleState.summaryPageData.pageSize
    });
    await inventoryModuleState.setLoading(false);*/
  }
  async loadMoreItems() {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.getInventoryItemsForLinking(null);
    await inventoryModuleState.setLoading(false);
  }

  async onSort(s) {
    await inventoryModuleState.setLoading(true);
    await inventoryModuleState.applyLinkItemListSort(s);
    await inventoryModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    inventoryModuleState.toggleItemField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.LINK_INVENTORY_ITEM_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get dataRetreived() {
    if(inventoryModuleState.linkItemData)
      return true;
    return false;
  }
}
